import cookies from "js-cookie";
import { useState, useEffect } from "react";

export const useMonetateId = () => {
  const [monetateId, setMonetateId] = useState<string>(
    () => (typeof window && cookies.get("mt.v")) || "",
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      setMonetateId(cookies.get("mt.v") || "");
    }
  }, []);

  return [monetateId, setMonetateId];
};
